// @flow
import React, {useState} from 'react';
import {Card, Typography, Divider} from '@material-ui/core';
import {Check, Delete, Edit} from '@material-ui/icons';
import {useHistory} from 'react-router-dom';
import CustomButton from '../../../../../../elements/CustomButton/CustomButton';
import DeleteConfirmationModal from '../../../../../products/components/DeleteConfirmationModal/DeleteConfirmationModal';
import {useCRUDStandardRate} from '../../utils';
import type {ShippingStandarRate, Currency} from '../../../../../../entities';
import ConfigCountryModal from '../../components/ConfigCountryModal';

type Props = {
  isNational: boolean,
  rate: ShippingStandarRate,
  classes: {
    card: string,
    header: string,
    textHeader: string,
    check: string,
    bold: string,
    buttonsHeader: string,
    deleteButton: string,
    editButton: string,
    containerData: string,
    textGrey: string,
    notCheck: string,
  },
  isEditable: boolean,
  currency: Currency,
};

export default function CardEstandarShipping(props: Props) {
  const {rate, classes, isNational, isEditable, currency} = props;
  const history = useHistory();
  const [showModalDeleteRate, setShowModalDeleteRate] = useState(false);
  const [showModalConfigCountry, setShowModalConfigCountry] = useState(false);
  const {
    isSaving,
    removeStandardRate,
    updateStandardRate,
  } = useCRUDStandardRate();

  const handleModalDeleteClose = () => {
    setShowModalDeleteRate(false);
  };

  const handleDeleteClick = () => {
    setShowModalDeleteRate(false);
    removeStandardRate(rate.id);
  };

  const handleChangeEnabled = () => {
    const formattedRateRequest = {
      enabled: !rate.enabled,
      displayName: rate.displayName,
    };

    updateStandardRate({
      standardRateId: rate.id,
      standardRate: formattedRateRequest,
    });
  };

  return (
    <>
      <Card variant="outlined" className={classes.card}>
        <div className={classes.header}>
          <div className={classes.textHeader}>
            <button
              className={rate.enabled ? classes.check : classes.notCheck}
              type="button"
              onClick={handleChangeEnabled}
              disabled={isSaving || !isEditable}
            >
              {rate.enabled ? <Check /> : null}
            </button>
            <Typography align="left" className={classes.bold}>
              {rate.displayName}
            </Typography>
          </div>
          <div className={classes.buttonsHeader}>
            <CustomButton
              className={classes.deleteButton}
              variant="text"
              startIcon={<Delete />}
              onClick={() => setShowModalDeleteRate(true)}
            >
              Eliminar
            </CustomButton>
            <Divider orientation="vertical" flexItem />
            <CustomButton
              className={classes.editButton}
              variant="text"
              startIcon={<Edit />}
              onClick={() => {
                if (isEditable) {
                  history.push(
                    `/configure/logistics/shipping/standard/${
                      isNational ? 'national' : 'international'
                    }/${rate.id}`
                  );
                } else {
                  setShowModalConfigCountry(true);
                }
              }}
            >
              Editar
            </CustomButton>
          </div>
        </div>
        <div className={classes.containerData}>
          <Typography align="left" className={classes.textGrey}>
            Costo: {currency.symbol} {rate.price}
          </Typography>
          <Typography align="left" className={classes.textGrey}>
            Mensaje: {rate.description}
          </Typography>
        </div>
      </Card>
      <DeleteConfirmationModal
        title="¿Seguro que quieres eliminar esta tarifa?"
        content="Si lo eliminas no lo podrás recuperar."
        open={showModalDeleteRate}
        handleClose={handleModalDeleteClose}
        handleDeleteClick={handleDeleteClick}
        disabled={isSaving}
      />

      <ConfigCountryModal
        open={showModalConfigCountry}
        handleClose={() => {
          setShowModalConfigCountry(false);
        }}
      />
    </>
  );
}
